const fonts = {
    body: 'work-sans, Helvetica Neue, Helvetica, sans-serif',
    heading: 'oswald, Helvetica Neue, Helvetica, sans-serif',
    playfair: 'playfair-display, serif',
    oswald: 'oswald, Helvetica Neue, Helvetica, sans-serif',
    workSans: 'work-sans, Helvetica Neue, Helvetica, sans-serif',
}

export default fonts
